import React from "react";
import Modal from "react-bootstrap/Modal";

const DeleteDocumentModal = ({ show, handleClose, filename, onConfirm }) => {
  return (
    <>
      <style>{`
        .delete-document-modal .modal-content {
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 18px;
          box-shadow: 0 20px 60px rgba(0,0,0,0.12);
        }
        .delete-document-modal .modal-header {
          background: #fff;
          border-bottom: 1px solid #f3f4f6;
          border-radius: 18px 18px 0 0;
          padding: 20px 24px 16px;
        }
        .delete-document-modal .modal-body {
          background: #fff;
          padding: 20px 24px;
        }
        .delete-document-modal .modal-footer {
          background: #f9fafb;
          border-top: 1px solid #f3f4f6;
          border-radius: 0 0 18px 18px;
          padding: 16px 24px;
        }
      `}</style>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="delete-document-modal"
        style={{ backdropFilter: "blur(3px)" }}
      >
        <Modal.Header closeButton>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{
              width: 34, height: 34, borderRadius: 9,
              background: "#fef2f2", border: "1.5px solid #fca5a5",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <i className="fas fa-trash-alt" style={{ color: "#ef4444", fontSize: 13 }} />
            </div>
            <div>
              <div style={{ fontWeight: 800, fontSize: 16, color: "#111827" }}>Delete Attachment</div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 1 }}>This action cannot be undone</div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div style={{
            background: "#fef2f2", border: "1px solid #fca5a5",
            borderRadius: 10, padding: "12px 14px",
            display: "flex", alignItems: "flex-start", gap: 10,
          }}>
            <i className="fas fa-exclamation-triangle" style={{ color: "#ef4444", fontSize: 13, marginTop: 1, flexShrink: 0 }} />
            <div style={{ fontSize: 13, color: "#991b1b", lineHeight: 1.6 }}>
              You are about to permanently delete{" "}
              {filename ? <b>{filename}</b> : "this attachment"}.
              {" "}This cannot be reversed.
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer style={{ display: "flex", gap: 10 }}>
          <button
            type="button"
            onClick={handleClose}
            style={{
              flex: 1, padding: "11px 0", borderRadius: 10,
              border: "1.5px solid #e5e7eb", background: "#fff",
              color: "#374151", fontWeight: 700, fontSize: 15,
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => { onConfirm(); handleClose(); }}
            style={{
              flex: 2, padding: "11px 0", borderRadius: 10, border: "none",
              background: "linear-gradient(135deg, #991b1b 0%, #ef4444 100%)",
              color: "#fff", fontWeight: 700, fontSize: 15,
              cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              gap: 9,
            }}
          >
            Delete Attachment
            <i className="fas fa-trash-alt" style={{ fontSize: 13 }} />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteDocumentModal;
